module.exports = __webpack_public_path__ + "img/hr-red-pita-14.9af8f3d4.png";